export default __webpack_public_path__ + "static/media/syracuse-logo-light.a77392af.png";